import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { decodeWithSalt } from "../utils/encodeFunctions";

/**
 * Custom hook to check if the user has permission to access a page.
 *
 * @param allowedRoles - Array of roles allowed to access the page.
 * @param redirectTo - Path to redirect to if the user is not authorized.
 */
const useAuthorization = (
  allowedRoles: string[] = [],
  redirectTo: string = "/unauthorized"
) => {
  const navigate = useNavigate();

  useEffect(() => {
    const role = decodeWithSalt(sessionStorage.getItem("role") ?? "");

    if (!role || !allowedRoles.includes(role)) {
      navigate(redirectTo, { replace: true });
    }
  }, [allowedRoles, redirectTo, navigate]);
};

export default useAuthorization;
